import styled, { css } from 'styled-components';
import { palette } from 'styles/colors';
import { layout } from 'styles/layout'
import { GatsbyImage, GatsbyImageProps } from 'gatsby-plugin-image';
import { Link } from 'gatsby';

interface DotItemProps {
  active: boolean
}

export const DotsContainer = styled.div`
  position: absolute;
  bottom: 10px;
`

export const DotItem = styled.div<DotItemProps>`
  margin: 0 0.3126em;
  width: 10px;
  height: 10px;
  cursor: pointer;
  border-radius: 50%;
  background: ${palette.white};
  opacity: ${({ active }) => active ? '1' : '.6'};
`

export const CreatorImagesContainer = styled.div`
  position: relative;
  max-width: 100vw;
  margin: 3.75em auto 0;
  box-sizing: border-box;
  padding-left: 30px;
  padding-right: 30px;

  .slick-arrow {
    width: 20px;
    height: 24px;
  }

  @media screen and (max-width: ${layout.xlg}) {
    padding-left: 50px;
    padding-right: 50px;
  }

  @media screen and (max-width: ${layout.sm}) {
    padding-left: 0;
    padding-right: 0;
  }
`

export const CreatorImage = styled(GatsbyImage) <GatsbyImageProps>`
  height: 315px;

  @media screen and (min-width: ${layout.sm}) {
    height: 500px;
  }
`

export const ChevronContainer = styled.div`
  align-self: center;
  justify-self: center;
  position: relative;
  cursor: pointer;
`

export const CreatorImageContainer = styled.div<{ animated?: boolean }>`
  position: relative;

  ${({ animated }) => animated ? '' : css`
    @keyframes fade {
      from {
        opacity: 0;
        transform: scale(1.5);
      }
      to {
        opacity: 1;
        transform: scale(1);
      }
    }

    animation: fade ease-in-out 300ms;
    opacity: 1;
    transform: scale(1);
  `}
`

export const CreatorImageSlider = styled.div`
  position: relative;
`

export const ImageAnimation = styled.div`
  transition: all ease-in-out 300ms;
  transform: scale(1.5);
  opacity: 0.5;
`

export const CreatorItem = styled(Link)`
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  min-height: initial;
  -webkit-user-drag: none;
  user-select: none;
  -moz-user-select: none;

  @media screen and (min-width: ${layout.xs}) {
    padding: 0 30px;
  }

  @media screen and (min-width: ${layout.sm}) {
    padding: 0 20px;
  }

  @media screen and (min-width: ${layout.subLg}) {
    padding: 0 20px;
  }
`

export const ImageShadow = styled.div`
  overflow: hidden;
  position: relative;
  background: ${palette.white};
  box-shadow: 0 0 1px rgb(0 0 0 / 5%), 0 1px 15px rgb(0 0 0 / 15%);

  &::before {
    background: linear-gradient(180deg, rgba(25,31,40,0) 60%,#000);
    bottom: 0;
    content: ''""'';
    left: 0;
    opacity: 0.6;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }
`

// absolute positioning extends div outside of parent padding's, calc and 1em is used to render it inside padding
export const ImageCaption = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 2em 4em 3em;
  z-index: 2;
  color: ${palette.white};
`

export const CreatorImageOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: linear-gradient(180.08deg, rgba(25, 31, 40, 0) 36.68%, #000 73.46%);
  opacity: .6;
  z-index: 1;
`
